const APP_CONFIG = {
  version: "7.85.0",
  title: "Claire V7.85.0",
  version_client: "7.85.0",
};

export default APP_CONFIG;
